import classNames from "classnames";
import { HTMLProps } from "react";

interface Props extends HTMLProps<HTMLTextAreaElement> {
  name?: string;
  required?: boolean;
  register?: any;
  className?: string;
  containerClassName?: string;
  labelClassName?: string;
  placeholder?: string;
}

const Textarea: React.FC<Props> = (props) => {
  const { className, containerClassName, labelClassName, placeholder, register, name, required, ...rest } = props;
  return (
    <div className={classNames(containerClassName, "w-full")}>
      <label className="flex flex-col">
        <span className={labelClassName ? labelClassName : ""}>{rest.label}</span>
        <textarea
          {...(name && { ...register(name, { required: required }) })}
          placeholder={placeholder}
          rows={8}
          className={classNames(
            className,
            "p-3 m-2 rounded-md border-1 shadow appearance-none ring-0 ring-pkc-silver focus:ring-2 transition-all ring-offset-0 focus:ring-offset-2 focus:outline-none focus:shadow-outline"
          )}
          {...rest}
        />
      </label>
    </div>
  );
};

export default Textarea;
